import { useState, useRef } from 'react';

export interface DropdownPosition {
  top: number;
  left: number;
}

export const useDropdownMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<DropdownPosition>({ top: 0, left: 0 });

  const handleMouseEnter = () => {
    if (dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top,
        left: rect.right
      });
    }
    setIsOpen(true);
  };

  const handleMenuMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMenuMouseLeave = () => {
    setIsOpen(false);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    setIsOpen,
    position,
    dropdownRef,
    menuRef,
    handlers: {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onMenuMouseEnter: handleMenuMouseEnter,
      onMenuMouseLeave: handleMenuMouseLeave
    }
  };
};
